

















































































import BaseComponent from '@/core/base.component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import authService from '@/services/shared/auth/auth.service';
import store from '@/store';
import { APPROVAL_STATUS } from '@/services/shared';
import { ChangePasswordDto } from '@/services/shared/auth';
@Component({
  name: 'PasswordChangeDialog',
})
export default class PasswordChangeDialog extends BaseComponent {
  private confirmPasswordLoading = false;
  private updatePasswordLoading = false;
  private showOldPassword = false;
  private showNewPassword = false;
  private showNewPasswordConfirm = false;
  private validatePasswordDto = new ChangePasswordDto();
  private updatePasswordDto = new ChangePasswordDto();
  private isPasswordValidated = false;
  private isOldPasswordFocused = false;
  private isNewPasswordFocused = false;
  @Prop() readonly dialog: boolean;

  get isNewPasswordMatched() {
    if (
      this.updatePasswordDto.password === this.updatePasswordDto.passwordConfirm
    ) {
      return true;
    } else {
      return false;
    }
  }
  get passwordLength() {
    if (this.updatePasswordDto.password) {
      return this.updatePasswordDto.password.length;
    } else {
      return 0;
    }
  }

  @Watch('dialog')
  onDialogChanged() {
    if (this.dialog) {
      this.isOldPasswordFocused = true;
    }
  }

  reset() {
    // this.userAddDialog = false;
    this.$emit('update:dialog', !this.dialog);
    this.isPasswordValidated = false;
    this.confirmPasswordLoading = false;
    this.updatePasswordLoading = false;
    this.validatePasswordDto = new ChangePasswordDto();
    this.updatePasswordDto = new ChangePasswordDto();
  }
  validatePassword() {
    this.confirmPasswordLoading = true;
    authService.validatePassword(this.validatePasswordDto).subscribe(res => {
      if (res) {
        this.confirmPasswordLoading = false;
        this.isPasswordValidated = res.data.isValidated;
        this.isNewPasswordFocused = true;
      } else {
        this.confirmPasswordLoading = false;
      }
    });
  }
  updatePassword() {
    this.updatePasswordLoading = true;
    authService.updatePassword(this.updatePasswordDto).subscribe(res => {
      if (res) {
        this.$toasted.global.custom_success({ message: '수정 성공!' });
        this.reset();
      }
    });
  }
}
